import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { Toaster } from 'sonner';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Noise overlay */}
      <div className="noise-overlay" />
      
      <Navbar />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
};
